import { RightWrongButtons } from '@components';
import { Flex } from '@styles';
import { arrayOf, bool, func, object, shape, string } from 'prop-types';
import React from 'react';

import TestAnswer from './TestAnswer';

const TestAnswerList = ({
  customButtonTitles,
  handleGoBack,
  handleReset,
  isTestFinished,
  isTestPassed,
  validatedAnswers,
}) => (
  <Flex flexDirection="column" mt={24}>
    {validatedAnswers?.map((answer, index) => (
      <TestAnswer
        explanation={answer?.explanation}
        index={index}
        isCorrect={answer?.is_correct}
        isRight={answer?.option}
        title={answer?.question}
      />
    ))}
    <RightWrongButtons
      customButtonTitles={customButtonTitles}
      isPassed={isTestFinished && isTestPassed}
      rightHandler={handleGoBack}
      withRetry={isTestFinished}
      wrongHandler={handleReset}
    />
  </Flex>
);

TestAnswerList.propTypes = {
  customButtonTitles: shape({ leftButton: string, rightButton: string }),
  handleGoBack: func.isRequired,
  handleReset: func.isRequired,
  isTestFinished: bool.isRequired,
  isTestPassed: bool.isRequired,
  validatedAnswers: arrayOf(object).isRequired,
};

TestAnswerList.defaultProps = {
  customButtonTitles: null,
};

export default TestAnswerList;
